export default __webpack_public_path__ + "static/media/gallery_08.27b56ac6.jpg";